// frontend/src/pages/DealerEnquiry.jsx

import React from "react";

const DealerEnquiry = () => {
  return (
    <main style={{ padding: "60px 20px" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>

        {/* PAGE IMAGE */}
        <img
          src="/images/dealer-partner.png"
          alt="Dealer and Channel Partner Network"
          style={{
            width: "100%",
            maxHeight: "420px",
            objectFit: "cover",
            borderRadius: "12px",
            marginBottom: "40px"
          }}
        />

        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Dealer & Channel Partner Enquiries
        </h1>

        <p style={{ fontSize: "18px", color: "#555", marginBottom: "30px" }}>
          Aerzen Air works with selected dealers and channel partners for institutional,
          commercial, and regional deployments. Partner selection is based on technical
          capability, service infrastructure, and market coverage.
        </p>

        <h2 style={{ fontSize: "26px", marginBottom: "12px" }}>
          Dealer Engagement Model
        </h2>

        <ul style={{ fontSize: "17px", color: "#444", lineHeight: "1.8" }}>
          <li>Institutional and bulk-focused deployments</li>
          <li>Service and installation capability preferred</li>
          <li>Region-wise engagement handled directly by Aerzen Air</li>
          <li>Commercial terms discussed offline</li>
        </ul>

        <p style={{ fontSize: "17px", color: "#555", marginTop: "30px" }}>
          To express interest in becoming an Aerzen Air dealer or channel partner,
          please contact our sales team with your company profile and operational details.
        </p>

        <div style={{ marginTop: "40px" }}>
          <a
            href="mailto:sales@aerzenair.com"
            style={{
              display: "inline-block",
              padding: "14px 28px",
              backgroundColor: "#0a2540",
              color: "#ffffff",
              textDecoration: "none",
              borderRadius: "6px",
              fontWeight: "600"
            }}
          >
            Contact Sales Team
          </a>
        </div>
      </div>
    </main>
  );
};

export default DealerEnquiry;
